import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { getNxMovesLeft, getNxScore } from "../store/actions";
import { PLAYER_NUMBER } from "../../../pages/GamePlay/types";
import { getScoreFlyAnimationConfig } from "../../../store/selectors/ludoboardSelectors";
import EventEmitter from "events";
import { _isNil } from "../../../utils/helpers/zupeeLodash";
import { useTranslation } from "react-i18next";

const MovesAndScore:React.FC = () => {

  // const movesAndScore = [
  //   {
  //     value: "36",
  //     label: "Moves Left"
  //   },
  //   {
  //     value: "0",
  //     label: "Score"
  //   },
  // ]
  const t = useTranslation();
  const movesLeft = useSelector(getNxMovesLeft);
  const score = useSelector(getNxScore);
  const [localScore, setLocalScore] = useState();
  const oldScore = useRef(null);
  const scoreFlyAnimationTimeOutRef = useRef(null)
  const scoreFlyAnimationConfig = useSelector(getScoreFlyAnimationConfig.bind(null, PLAYER_NUMBER.ONE));
  const DeviceEventEmitter = new EventEmitter();

  // useEffect(() => {
  //   const listener = DeviceEventEmitter.addListener('incrementScore', () => {
  //     setLocalScore(curr => {
  //       oldScore.current = curr
  //       return curr + 1
  //     })
  //   })

  //   return listener?.remove
  // }, [])

  // useEffect(() => {
  //   setLocalScore(old => {
  //     oldScore.current = old
  //     return score
  //   })
  // }, [score])

  // useEffect(() => {
  //   if (!_isNil(scoreFlyAnimationConfig)) {
  //     scoreFlyAnimationTimeOutRef.current = setTimeout(() => {
  //       setLocalScore(old => {
  //         oldScore.current = old
  //         return old + scoreFlyAnimationConfig.score
  //       })
  //       resetScoreFlyAnimationConfigForToken(PLAYER_NUMBER.ONE)
  //     }, 1000)
  //   }
  //   return () => { clearTimeout(scoreFlyAnimationTimeOutRef.current) }
  // }, [scoreFlyAnimationConfig])

  return(
    <>
      <div className={clsx(styles.movesAndScoreContainer)}>

          <div className={clsx(styles.contentWrapper, "flex alignItemCenter justifyContentCenter textAlignCenter")}>
            <div className={clsx(styles.contentValue, styles.column, "fontSizeSm18 fontWeightBold fontColorWhite")}>{movesLeft}</div>
            <div className={clsx(styles.label, styles.column, "fontSizeXs fontWeightRegular fontColorWhite")}>{t.t("movesLeft")}</div>
          </div>

          <div className={clsx(styles.contentWrapper, "flex alignItemCenter justifyContentCenter textAlignCenter")}>
            <div className={clsx(styles.contentValue, styles.column, "fontSizeSm18 fontWeightBold fontColorWhite")}>{score}</div>
            <div className={clsx(styles.label, styles.column, "fontSizeXs fontWeightRegular fontColorWhite")}>{t.t("score")}</div>
          </div>

      </div>
    </>
  )
}
export default MovesAndScore;